import { Component, OnInit, inject } from '@angular/core'
import { Router } from '@angular/router'
import { ROLES } from 'src/app/core/modules/sistema/enums/roles.enum'
import { ILoginRequest } from 'src/app/core/modules/sistema/models/ILoginRequest.interface'
import { IMenu } from 'src/app/core/modules/sistema/models/IMenu.interface'
import { SeguridadService } from 'src/app/core/modules/sistema/services/seguridad/seguridad.service'
import { UsuarioMenuService } from 'src/app/core/modules/sistema/services/usuarioMenu.service'
import { SpinnerService } from 'src/app/core/services/spinner.service'
import { MessageUtil } from 'src/app/core/utils/message.util'

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  standalone: false,
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {
  private _spinnerService = inject(SpinnerService)
  private _router = inject(Router)
  private _seguridadService = inject(SeguridadService)
  private _usuarioMenuService = inject(UsuarioMenuService)

  loginRequest: ILoginRequest = {
    nombreUsuario: '',
    contrasena: '',
  }

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[])

  constructor() {}

  ngOnInit(): void {
    if (this._seguridadService.esSesionActiva()) {
      this._router.navigate(['/dashboard'])
    }

  }

  public login(): void {
    if (!this.loginRequest.nombreUsuario || !this.loginRequest.contrasena) {
      MessageUtil.showWarning('El usuario y contraseña son requeridos')
      return
    }

    this._spinnerService.show()
    this._seguridadService.login(this.loginRequest).subscribe({
      next: (data) => {
        this._seguridadService.procesarToken(data.result)
        this.validarMenus()
      },
      error: (e) => {
        this._spinnerService.hide()
        MessageUtil.showError(e)
      },
    })
  }

  public validarMenus(): void {
    this._usuarioMenuService.ObtenerMenuPorUsuario(+this._seguridadService.obtenerUsuarioId()).subscribe({
      next: (data) => {
        if (data.result.length === 0) {
          MessageUtil.showWarning(
            'El usuario no tiene ninguna opción de menu asignada, por favor comuniquese con el Gerente de Cuenta e intente nuevamente.',
            () => {
              this.logout()
            },
          )
          return
        }

        this._seguridadService.Menus = data.result as Array<IMenu>

        if (this._seguridadService.obtenerRol() === ROLES.Administrador) {
          this._router.navigate(['/main/inicio'])
          return
        }
        this._router.navigate(['/dashboard'])
      },
      error: (e) => {
        this._spinnerService.hide()
        MessageUtil.showError(e, () => {
          this.logout()
        })
      },
      complete: () => {
        this._spinnerService.hide()
      },
    })
  }

  public logout(): void {
    this._seguridadService.logout().subscribe({
      next: (_) => {
        console.info('LoginComponent: logout')
      },
      error: () => {
        this._seguridadService.limpiarSesion()
        this._router.navigate(['/main'])
      },
      complete: () => {
        this._seguridadService.limpiarSesion()
        this._router.navigate(['/main'])
      },
    })
  }

}
